import axios from "axios";

const getTmaxBaseUrl = () =>
  process.env.REACT_APP_TMAX_BASE_URL ||
  process.env.TMAX_BASE_URL ||
  "http://localhost:8090";

/** Empty string / null / NaN → fallback (default 0). */
function toNonNegativeInt(value: unknown, fallback = 0): number {
  if (value === "" || value == null) return fallback;
  const n = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(n) || n < 0) return fallback;
  return Math.floor(n);
}

export const checkTmaxHealth = async () => {
  try {
    const response = await axios.get(`${getTmaxBaseUrl()}/api/health`);
    return response.data;
  } catch (error) {
    console.error("TMAX Health Check Error:", error);
    throw error;
  }
};

export const startTmaxSession = async (
  tmaxId: number | string,
  minutes: number | string,
  delay: number | string | null | undefined = 0,
) => {
  try {
    const mins = toNonNegativeInt(minutes, 0);
    const delayMins = toNonNegativeInt(delay, 0);
    const response = await axios.post(
      `${getTmaxBaseUrl()}/api/rooms/${tmaxId}/start?minutes=${mins}&delay=${delayMins}`,
    );
    return response.data;
  } catch (error) {
    console.error("TMAX Start Session Error:", error);
    throw error;
  }
};

export const cancelTmaxSession = async (tmaxId: number | string) => {
  try {
    const response = await axios.post(
      `${getTmaxBaseUrl()}/api/rooms/${tmaxId}/cancel`,
    );
    return response.data;
  } catch (error) {
    console.error("TMAX Cancel Session Error:", error);
    throw error;
  }
};
